import { AppShell, PageGridCell, PageGridContainer, PageGridRow, useDetectDeviceSize } from "@wayflyer/flyui";
import Cookies from "js-cookie";
import { usePostHog } from "posthog-js/react";
import { useMount } from "shared-utils";
import { useCobrandingConfig } from "undercarriage";

import { DescriptionCards, GetStartedSection } from "../../components";
import { useLandingPageViewProperties } from "../../queries/landing-page-view/queries";

const WF_INVITE_COOKIE_NAME = "wf_invite";

export const WayflyerHostedCapital = () => {
  const { isMobile } = useDetectDeviceSize();
  const { data: cobrandingLogos } = useCobrandingConfig();
  const posthog = usePostHog();

  // Query to fetch landing page view properties
  const { refetch } = useLandingPageViewProperties();

  // Trigger tracking when component mounts if invite token exists
  useMount(() => {
    const inviteToken = Cookies.get(WF_INVITE_COOKIE_NAME);

    if (inviteToken) {
      // Fetch properties from backend
      refetch()
        .then(({ data }) => {
          if (posthog && data) {
            const companyData = {
              customer_id: data.customer_id,
              customer_name: data.customer_name,
              customer_domain: data.customer_domain,
              company_public_id: data.company_public_id,
              country_of_incorporation: data.country_of_incorporation ?? undefined,
              is_test: data.is_test,
              industry: data.industry ?? undefined,
            };
            // Identify the user first to link anonymous session to email
            posthog.identify(data.email, {
              email: data.email,
              ...companyData,
            });

            // Capture PostHog event with the properties from the backend
            posthog.capture("hosted_capital_landing_page_viewed", {
              email: data.email,
              ...companyData,
            });

            // Associate with company group
            posthog.group("company", data.company_public_id, {
              name: data.customer_name,
              ...companyData,
            });
          }
        })
        .catch(() => {
          // Silently fail - tracking is best-effort
        });
    }
  });

  return (
    <AppShell
      skeleton
      logoLink={{
        accessibilityLabel: "Homepage",
        url: `${window.location.protocol}//${window.location.host}`,
      }}
      secondaryLogo={{
        alt: cobrandingLogos?.partnerName || "",
        lightIconLogoUrl: cobrandingLogos?.lightIconLogoUrl,
        darkIconLogoUrl: cobrandingLogos?.darkIconLogoUrl,
        lightLogoUrl: cobrandingLogos?.lightLogoUrl,
        darkLogoUrl: cobrandingLogos?.darkLogoUrl,
      }}
    >
      <PageGridContainer constrainWidth>
        <PageGridRow>
          <PageGridCell
            layout={{
              xxl: { span: 12 },
            }}
          >
            <GetStartedSection cobrandingPartnerName={cobrandingLogos?.partnerName} isMobile={isMobile} />
          </PageGridCell>
        </PageGridRow>
        <PageGridRow>
          <PageGridCell
            layout={{
              xxl: { span: 12 },
            }}
          >
            <DescriptionCards />
          </PageGridCell>
        </PageGridRow>
      </PageGridContainer>
    </AppShell>
  );
};
